import React, { useEffect } from 'react';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const contentStyle = {
  position: 'relative',
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  maxWidth: '90%',
  maxHeight: '90%',
  overflow: 'hidden',
};

const closeButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  backgroundColor: '#ff4d4f',
  color: 'white',
  border: 'none',
  borderRadius: '50%',
  width: '30px',
  height: '30px',
  fontSize: '16px',
  cursor: 'pointer',
};

const ImageModal = ({ image, isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div style={overlayStyle} onClick={onClose} role="dialog" aria-modal="true">
      <div style={contentStyle} onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          style={closeButtonStyle}
          onClick={onClose}
          aria-label="Chiudi anteprima"
        >
          ×
        </button>
        <img
          src={image}
          alt="Ingrandimento"
          style={{
            maxWidth: '100%',
            maxHeight: '80vh',
            display: 'block',
            margin: '0 auto',
          }}
        />
      </div>
    </div>
  );
};

export default ImageModal;
